<template>
    <IconSvg viewBox="0 0 48 24" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.1802 19.2669L11.0589 17.1456L23.3223 4.88212C23.7129 4.4916 24.346 4.4916 24.7365 4.88212L37 17.1456L34.8787 19.2669L24.0294 8.41766L13.1802 19.2669Z"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
